import React, { useEffect } from 'react';
import './BrochureModal.css';

const BrochureModal = ({ isOpen, onClose, onCloseAndReopenMenu }) => {
  const containerId = 'zf_div_r6uMUuOaKLmmAL4vq6NlVJKKNwUBqURYrMPKFb1gmaQ';

  // Initialize Zoho Form when modal opens
  useEffect(() => {
    if (isOpen) {
      const initZohoForm = () => {
    try {
      const container = document.getElementById(containerId);
      if (!container) return;

      // Check if iframe already exists - if it does, don't recreate
      if (container.querySelector('iframe')) {
        return;
      }

      var f = document.createElement("iframe");
      var ifrmSrc = 'https://forms.zohopublic.com/nexuslivinglimited1/form/GettheBrochureHomepage/formperma/r6uMUuOaKLmmAL4vq6NlVJKKNwUBqURYrMPKFb1gmaQ?zf_rszfm=1';

      // Pass through UTM parameters from current page
      function passthroughParams(url) {
        var pageQS = new URLSearchParams(window.location.search);
        var keys = ["utm_source","utm_medium","utm_campaign","utm_term","utm_content","gclid","fbclid"];
        var extra = new URLSearchParams();
        keys.forEach(function(k){ if (pageQS.get(k)) extra.set(k, pageQS.get(k)); });
        return extra.toString() ? url + (url.indexOf("?")>-1 ? "&" : "?") + extra.toString() : url;
      }

      // Append Zoho advanced parameters if available
      try {
        if (typeof ZFAdvLead !== "undefined" && typeof zfutm_zfAdvLead !== "undefined") {
          for (var prmIdx = 0; prmIdx < ZFAdvLead.utmPNameArr.length; prmIdx++) {
            var utmPm = ZFAdvLead.utmPNameArr[prmIdx];
            utmPm = (ZFAdvLead.isSameDomian && (ZFAdvLead.utmcustPNameArr.indexOf(utmPm) == -1)) ? "zf_" + utmPm : utmPm;
            var utmVal = zfutm_zfAdvLead.zfautm_gC_enc(ZFAdvLead.utmPNameArr[prmIdx]);
            if (typeof utmVal !== "undefined") {
              if (utmVal != "") {
                if (ifrmSrc.indexOf('?') > 0) {
                  ifrmSrc = ifrmSrc + '&' + utmPm + '=' + utmVal;
                } else {
                  ifrmSrc = ifrmSrc + '?' + utmPm + '=' + utmVal;
                }
              }
            }
          }
        }
        if (typeof ZFLead !== "undefined" && typeof zfutm_zfLead !== "undefined") {
          for (var prmIdx = 0; prmIdx < ZFLead.utmPNameArr.length; prmIdx++) {
            var utmPm = ZFLead.utmPNameArr[prmIdx];
            var utmVal = zfutm_zfLead.zfutm_gC_enc(ZFLead.utmPNameArr[prmIdx]);
            if (typeof utmVal !== "undefined") {
              if (utmVal != "") {
                if (ifrmSrc.indexOf('?') > 0) {
                  ifrmSrc = ifrmSrc + '&' + utmPm + '=' + utmVal;
                } else {
                  ifrmSrc = ifrmSrc + '?' + utmPm + '=' + utmVal;
                }
              }
            }
          }
        }
      } catch (e) {}

      // Apply UTM passthrough
      ifrmSrc = passthroughParams(ifrmSrc);

      f.src = ifrmSrc;
      f.style.border = "none";
      f.style.height = "700px";
      // Set width to 100% by default, CSS will override for desktop
      f.style.width = "100%";
      f.style.transition = "all 0.5s ease";
      f.setAttribute("aria-label", 'Get the Brochure');
      f.setAttribute("title", 'Get the Brochure');
      f.setAttribute("loading", "lazy");
      f.setAttribute("allow", "clipboard-write; geolocation; fullscreen");
      f.setAttribute("referrerpolicy", "strict-origin-when-cross-origin");

      container.appendChild(f);

      // Listen for height adjustment messages
      window.addEventListener('message', function(event) {
        var ALLOWED_ORIGINS = ["https://forms.zohopublic.com", "https://forms.zoho.com"];
        if (!ALLOWED_ORIGINS.includes(event.origin)) return;

        var evntData = event.data;
        if (evntData && evntData.constructor == String) {
          var zf_ifrm_data = evntData.split("|");
          if (zf_ifrm_data.length == 2 || zf_ifrm_data.length == 3) {
            var zf_perma = zf_ifrm_data[0];
            var zf_ifrm_ht_nw = (parseInt(zf_ifrm_data[1], 10) + 50) + "px";
            var iframe = container.getElementsByTagName("iframe")[0];
            if (iframe && iframe.src.indexOf('formperma') > 0 && iframe.src.indexOf(zf_perma) > 0) {
              var prevIframeHeight = iframe.style.height;
              var zf_tout = false;
              if (zf_ifrm_data.length == 3) {
                iframe.scrollIntoView();
                zf_tout = true;
              }
              if (prevIframeHeight != zf_ifrm_ht_nw) {
                if (zf_tout) {
                  setTimeout(function() {
                    iframe.style.height = zf_ifrm_ht_nw;
                  }, 500);
                } else {
                  iframe.style.height = zf_ifrm_ht_nw;
                }
              }
            }
          }
        }
      }, false);
    } catch (e) {
      console.error('Error initializing Zoho form:', e);
    }
      };

      initZohoForm();
    }
  }, [isOpen]);

  // Clean up iframe when modal closes
  useEffect(() => {
    if (!isOpen) {
      const container = document.getElementById(containerId);
      if (container) {
        const iframe = container.querySelector('iframe');
        if (iframe) {
          // Remove the iframe when modal closes to ensure fresh load on next open
          iframe.remove();
        }
      }
    }
  }, [isOpen]);

  const handleClose = () => {
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-logo">
          <img src="/images/logos/nexus-logo.svg" alt="Nexus Living" />
        </div>
        <button 
          className="modal-close-btn" 
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (onCloseAndReopenMenu) {
              onCloseAndReopenMenu();
            } else {
              handleClose();
            }
          }}
        >
          <img src="/images/icons/close-icon.svg" alt="Close" />
        </button>
        <div className="brochure-form">
          <div id={containerId} style={{ width: '100%', overflow: 'hidden' }}></div>
        </div>
      </div>
    </div>
  );
};

export default BrochureModal;
